import { Helmet } from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestVideos from './components/LatestVideos';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '福利视频大全',
  url: 'https://fulivideo.com',
  description: '福利视频专题页，汇聚海量精选福利视频资源，涵盖各类热门内容，免费在线观看，持续更新不断。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://fulivideo.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <Helmet>
        <title>福利视频大全 – 精选资源免费看 | 每日更新热门福利视频</title>
        <meta name="description" content="福利视频专题页，汇聚海量精选福利视频资源，涵盖各类热门内容，免费在线观看，持续更新不断。无论你喜欢哪种风格，这里都能找到超值福利视频，收藏本页即可随时享受最新最全内容。" />
        <meta name="keywords" content="福利视频,福利视频大全,免费福利视频,热门福利视频在线看,最新福利视频资源,精选福利视频合集,每日福利视频更新" />
        <link rel="canonical" href="https://fulivideo.com" />
        <meta property="og:title" content="福利视频大全 – 精选资源免费看" />
        <meta property="og:description" content="福利视频专题页，汇聚海量精选福利视频资源，涵盖各类热门内容，免费在线观看，持续更新不断。" />
        <meta property="og:url" content="https://fulivideo.com" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify(homeSchema)}
        </script>
      </Helmet>

      <main>
        <HeroSection />
        <CategorySection />
        <LatestVideos />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}